<lib-page
  [page]="surveyRenderStore.currentPageState().page!"
  class="block w-full rounded-2xl p-6 md:p-10 transition-all"
  [isValid]="surveyRenderStore.isPageValid()"
  (pageAction)="onPageAction($event)"
>
</lib-page>
